import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { CanvasTexture, RepeatWrapping, SRGBColorSpace, VideoTexture } from 'three';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { $needsRender, $onModelLoad, $progressTracker, $renderer, $scene } from '../model-viewer-base.js';
import GLTFExporterMaterialsVariantsExtension from '../three-components/gltf-instance/VariantMaterialExporterPlugin.js';
import { $availableVariants, $materialFromPoint, $prepareVariantsForExport, $switchVariant, Model } from './scene-graph/model.js';
import { Texture as ModelViewerTexture } from './scene-graph/texture.js';
export var $currentGLTF = Symbol('currentGLTF');
export var $originalGltfJson = Symbol('originalGltfJson');
export var $model = Symbol('model');
var $getOnUpdateMethod = Symbol('getOnUpdateMethod');
var $buildTexture = Symbol('buildTexture');
/**
 * SceneGraphMixin manages exposes a model API in order to support operations on
 * the <model-viewer> scene graph.
 */
export var SceneGraphMixin = function SceneGraphMixin(ModelViewerElement) {
  var _a, _b, _c;
  var SceneGraphModelViewerElement = /*#__PURE__*/function (_ModelViewerElement, _ref) {
    _inherits(SceneGraphModelViewerElement, _ModelViewerElement);
    var _super = _createSuper(SceneGraphModelViewerElement);
    function SceneGraphModelViewerElement() {
      var _this;
      _classCallCheck(this, SceneGraphModelViewerElement);
      _this = _super.apply(this, arguments);
      _this[_a] = undefined;
      _this[_b] = null;
      _this[_c] = null;
      _this.variantName = null;
      _this.orientation = '0 0 0';
      _this.scale = '1 1 1';
      return _this;
    }
    // Scene-graph API:
    /** @export */
    _createClass(SceneGraphModelViewerElement, [{
      key: "model",
      get: function get() {
        return this[$model];
      }
    }, {
      key: "availableVariants",
      get: function get() {
        return this.model ? this.model[$availableVariants]() : [];
      }
      /**
       * Returns a deep copy of the gltf JSON as loaded. It will not reflect
       * changes to the scene-graph, nor will editing it have any effect.
       */
    }, {
      key: "originalGltfJson",
      get: function get() {
        return this[$originalGltfJson];
      }
    }, {
      key: _ref,
      value: function value() {
        var _this2 = this;
        return function () {
          _this2[$needsRender]();
        };
      }
    }, {
      key: $buildTexture,
      value: function value(texture) {
        // Applies glTF default settings.
        texture.colorSpace = SRGBColorSpace;
        texture.wrapS = RepeatWrapping;
        texture.wrapT = RepeatWrapping;
        return new ModelViewerTexture(this[$getOnUpdateMethod](), texture);
      }
    }, {
      key: "createTexture",
      value: function () {
        var _createTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(uri) {
          var type,
            textureUtils,
            texture,
            _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                type = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'image/png';
                textureUtils = this[$renderer].textureUtils;
                _context.next = 4;
                return textureUtils.loadImage(uri);
              case 4:
                texture = _context.sent;
                texture.userData.mimeType = type;
                return _context.abrupt("return", this[$buildTexture](texture));
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function createTexture(_x) {
          return _createTexture.apply(this, arguments);
        }
        return createTexture;
      }()
    }, {
      key: "createLottieTexture",
      value: function () {
        var _createLottieTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(uri) {
          var quality,
            textureUtils,
            texture,
            _args2 = arguments;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                quality = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
                textureUtils = this[$renderer].textureUtils;
                _context2.next = 4;
                return textureUtils.loadLottie(uri, quality);
              case 4:
                texture = _context2.sent;
                return _context2.abrupt("return", this[$buildTexture](texture));
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function createLottieTexture(_x2) {
          return _createLottieTexture.apply(this, arguments);
        }
        return createLottieTexture;
      }()
    }, {
      key: "createVideoTexture",
      value: function createVideoTexture(uri) {
        var video = document.createElement('video');
        video.crossOrigin = this.withCredentials ? 'use-credentials' : 'anonymous';
        video.src = uri;
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        video.play();
        var texture = new VideoTexture(video);
        return this[$buildTexture](texture);
      }
    }, {
      key: "createCanvasTexture",
      value: function createCanvasTexture() {
        var canvas = document.createElement('canvas');
        var texture = new CanvasTexture(canvas);
        return this[$buildTexture](texture);
      }
    }, {
      key: "updated",
      value: function () {
        var _updated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(changedProperties) {
          var updateVariantProgress, model, variantName, scene;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _get(_getPrototypeOf(SceneGraphModelViewerElement.prototype), "updated", this).call(this, changedProperties);
                if (!changedProperties.has('variantName')) {
                  _context3.next = 12;
                  break;
                }
                updateVariantProgress = this[$progressTracker].beginActivity('variant-update');
                updateVariantProgress(0.1);
                model = this[$model];
                variantName = this.variantName;
                if (!(model != null)) {
                  _context3.next = 11;
                  break;
                }
                _context3.next = 9;
                return model[$switchVariant](variantName);
              case 9:
                this[$needsRender]();
                this.dispatchEvent(new CustomEvent('variant-applied'));
              case 11:
                updateVariantProgress(1.0);
              case 12:
                if (!(changedProperties.has('orientation') || changedProperties.has('scale'))) {
                  _context3.next = 21;
                  break;
                }
                if (this.loaded) {
                  _context3.next = 15;
                  break;
                }
                return _context3.abrupt("return");
              case 15:
                scene = this[$scene];
                scene.applyTransform();
                scene.updateBoundingBox();
                scene.updateShadow();
                this[$renderer].arRenderer.onUpdateScene();
                this[$needsRender]();
              case 21:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function updated(_x3) {
          return _updated.apply(this, arguments);
        }
        return updated;
      }()
    }, {
      key: $onModelLoad,
      value: function value() {
        _get(_getPrototypeOf(SceneGraphModelViewerElement.prototype), $onModelLoad, this).call(this);
        var currentGLTF = this[$scene].currentGLTF;
        if (currentGLTF != null) {
          var correlatedSceneGraph = currentGLTF.correlatedSceneGraph;
          if (correlatedSceneGraph != null && currentGLTF !== this[$currentGLTF]) {
            this[$model] = new Model(correlatedSceneGraph, this[$getOnUpdateMethod]());
            this[$originalGltfJson] = JSON.parse(JSON.stringify(correlatedSceneGraph.gltf));
          }
          // KHR_materials_variants extension spec:
          // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_variants
          if ('variants' in currentGLTF.userData) {
            this.requestUpdate('variantName');
          }
        }
        this[$currentGLTF] = currentGLTF;
      }
      /** @export */
    }, {
      key: "exportScene",
      value: function () {
        var _exportScene = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(options) {
          var _this3 = this;
          var scene;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                scene = this[$scene];
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve, reject) {
                    var opts, shadow, visible, exporter;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          // Defaults
                          opts = {
                            binary: true,
                            onlyVisible: true,
                            maxTextureSize: Infinity,
                            includeCustomExtensions: false,
                            forceIndices: false
                          };
                          Object.assign(opts, options);
                          // Not configurable
                          opts.animations = scene.animations;
                          opts.truncateDrawRange = true;
                          shadow = scene.shadow;
                          visible = false; // Remove shadow from export
                          if (shadow != null) {
                            visible = shadow.visible;
                            shadow.visible = false;
                          }
                          _context4.next = 9;
                          return _this3[$model][$prepareVariantsForExport]();
                        case 9:
                          exporter = new GLTFExporter().register(function (writer) {
                            return new GLTFExporterMaterialsVariantsExtension(writer);
                          });
                          exporter.parse(scene.model, function (gltf) {
                            return resolve(new Blob([opts.binary ? gltf : JSON.stringify(gltf)], {
                              type: opts.binary ? 'application/octet-stream' : 'application/json'
                            }));
                          }, function () {
                            return reject('glTF export failed');
                          }, opts);
                          if (shadow != null) {
                            shadow.visible = visible;
                          }
                        case 12:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x5, _x6) {
                    return _ref2.apply(this, arguments);
                  };
                }()));
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function exportScene(_x4) {
          return _exportScene.apply(this, arguments);
        }
        return exportScene;
      }()
    }, {
      key: "materialFromPoint",
      value: function materialFromPoint(pixelX, pixelY) {
        var model = this[$model];
        if (model == null) {
          return null;
        }
        var scene = this[$scene];
        var ndcCoords = scene.getNDC(pixelX, pixelY);
        var hit = scene.hitFromPoint(ndcCoords);
        if (hit == null || hit.face == null) {
          return null;
        }
        return model[$materialFromPoint](hit);
      }
    }]);
    return SceneGraphModelViewerElement;
  }(ModelViewerElement, (_a = $model, _b = $currentGLTF, _c = $originalGltfJson, $getOnUpdateMethod));
  __decorate([property({
    type: String,
    attribute: 'variant-name'
  })], SceneGraphModelViewerElement.prototype, "variantName", void 0);
  __decorate([property({
    type: String,
    attribute: 'orientation'
  })], SceneGraphModelViewerElement.prototype, "orientation", void 0);
  __decorate([property({
    type: String,
    attribute: 'scale'
  })], SceneGraphModelViewerElement.prototype, "scale", void 0);
  return SceneGraphModelViewerElement;
};